var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfReviewDocGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.017 2.81401C11.0598 2.58462 11.1815 2.37743 11.3611 2.22833C11.5406 2.07924 11.7666 1.99762 12 1.99762C12.2333 1.99762 12.4593 2.07924 12.6389 2.22833C12.8184 2.37743 12.9401 2.58462 12.983 2.81401L14.034 8.37201C14.1086 8.76716 14.3006 9.13063 14.585 9.41498C14.8693 9.69934 15.2328 9.89137 15.628 9.96601L21.186 11.017C21.4153 11.0599 21.6225 11.1816 21.7716 11.3611C21.9207 11.5406 22.0023 11.7667 22.0023 12C22.0023 12.2334 21.9207 12.4594 21.7716 12.6389C21.6225 12.8184 21.4153 12.9402 21.186 12.983L15.628 14.034C15.2328 14.1087 14.8693 14.3007 14.585 14.585C14.3006 14.8694 14.1086 15.2329 14.034 15.628L12.983 21.186C12.9401 21.4154 12.8184 21.6226 12.6389 21.7717C12.4593 21.9208 12.2333 22.0024 12 22.0024C11.7666 22.0024 11.5406 21.9208 11.3611 21.7717C11.1815 21.6226 11.0598 21.4154 11.017 21.186L9.96595 15.628C9.89131 15.2329 9.69928 14.8694 9.41492 14.585C9.13057 14.3007 8.7671 14.1087 8.37195 14.034L2.81395 12.983C2.58456 12.9402 2.37737 12.8184 2.22827 12.6389C2.07917 12.4594 1.99756 12.2334 1.99756 12C1.99756 11.7667 2.07917 11.5406 2.22827 11.3611C2.37737 11.1816 2.58456 11.0599 2.81395 11.017L8.37195 9.96601C8.7671 9.89137 9.13057 9.69934 9.41492 9.41498C9.69928 9.13063 9.89131 8.76716 9.96595 8.37201L11.017 2.81401Z",
    stroke: "#0F4B47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2V6",
    stroke: "#0F4B47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4H18",
    stroke: "#0F4B47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22C5.10457 22 6 21.1046 6 20C6 18.8954 5.10457 18 4 18C2.89543 18 2 18.8954 2 20C2 21.1046 2.89543 22 4 22Z",
    stroke: "#0F4B47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfReviewDocGreen);
export default __webpack_public_path__ + "static/media/pdf-review-doc-green.9bdf2b01955283ae738c74087a7e366a.svg";
export { ForwardRef as ReactComponent };